import React, { useState } from 'react';
import {
    Box, Button, Modal, Typography, Table, TableBody, TableContainer,
    TableHead, TableRow, IconButton, Tooltip, Paper, Grid, TablePagination,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import EditIcon from '@mui/icons-material/Edit';
import BlockIcon from '@mui/icons-material/Block';
import AddIcon from '@mui/icons-material/Add';
import CreateModuleModal from './CreateModuleModal';
import { disableModule } from '../../../services/adminServices/ModuleServices';
import { toast } from 'react-toastify';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#7e7e7e",
        color: theme.palette.common.white,
        textTransform: "capitalize",
        // textAlign: "center",
        fontSize: 16,
        fontWeight:600
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        // textAlign: "center",
        textTransform: "capitalize",

    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd),&:nth-of-type(even)": {
        backgroundColor: theme.palette.action.hover,
        borderBottom: "1px solid rgba(224, 224, 224, 1)",
    },
    "&:last-child td, &:last-child th": {
        border: 0,
    },
}));

 

function ModuleListModal({ modules,fetchModules,isAddModuleModalOpen, handleModuleSelectClose }) {
    const [isCreateModuleModalOpen, setCreateModuleModalOpen] = useState(false);
    const [editableModule, setEditableModule] = useState(null);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
  

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleEdit = (module) => {
        setEditableModule(module);
        setCreateModuleModalOpen(true);
    };
    const onDisableClick = async (moduleId) => {
        try {
          const response = await disableModule(moduleId);
          toast.success(response.data.message)
          fetchModules()
        } catch (error) {
            toast.error( error?.response?.data.message||error?.message ||error?.error);
        }
      }

    const handleOpenCreateModuleModal = () => {
        setEditableModule(null);
        setCreateModuleModalOpen(true);
    };

    const handleCloseCreateModuleModal = () => {
        setCreateModuleModalOpen(false);
    };

    const paginatedModules = modules?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

    return (
        <>
            <Modal open={isAddModuleModalOpen} onClose={handleModuleSelectClose}>
                <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '50%', bgcolor: 'background.paper', boxShadow: 24, p: 4, borderRadius: 2 }}>
                    <Grid container alignItems="center" justifyContent="space-between" spacing={2}>
                        <Grid item xs={6}>
                            <Typography variant="h6" sx={{ mb: 2 }}>Module List</Typography>
                        </Grid>
                        <Grid item xs={6} container justifyContent="flex-end" sx={{ mb: 2 }}>
                            <Tooltip title="Add New Module" arrow>
                                <IconButton onClick={handleOpenCreateModuleModal}>
                                    <AddIcon />
                                </IconButton>
                            </Tooltip>
                        </Grid>
                    </Grid>

                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <StyledTableCell>Module</StyledTableCell>
                                    <StyledTableCell>Action</StyledTableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {paginatedModules?.map((module) => (
                                    <StyledTableRow key={module.id}>
                                        <StyledTableCell>{module.module_Name}</StyledTableCell>
                                        <StyledTableCell>
                                            <Tooltip title="Edit">
                                                <IconButton size="small" aria-label="edit" onClick={() => handleEdit(module)}>
                                                    <EditIcon fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title="Disable">
                                                <IconButton size="small" aria-label="disable" onClick={() => onDisableClick(module.id)} >
                                                    <BlockIcon fontSize="small" />
                                                </IconButton>
                                            </Tooltip>
                                        </StyledTableCell>
                                    </StyledTableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <TablePagination
                        rowsPerPageOptions={[10,20,30,60,100]}
                        component="div"
                        count={modules?.length || 0}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />

                    <Box mt={3} textAlign="center">
                        <Button variant="outlined" color="secondary" onClick={handleModuleSelectClose}>Close</Button>
                    </Box>
                </Box>
            </Modal>

            <CreateModuleModal
                isOpen={isCreateModuleModalOpen}
                onClose={handleCloseCreateModuleModal}
                editableModule={editableModule}
                fetchModules={fetchModules}
            />
        </>
    );
}

export default ModuleListModal;
